import * as React from 'react';
import * as moment from 'moment';
import { Card, Tabs, TabPanel, Button, CheckBox, ButtonGroup, Popover } from 'sha-el-design';
import { callResponseSchema, CallResponse } from './constant';
import { Questions } from './Questions';
import { OrderBooking } from './OrderBooking';
import {
  ProductNode,
  CallResponseMutationInput,
  CallHistoryMutationInput,
  CallStatusEnum,
  ProductNodeEdge,
} from '../../../schema';
import { CompetitorPricing } from './CompetitorPricing';
import { fromGlobalId } from '../../helpers';

export class Response extends React.Component<Props, State> {
  products: ProductNode[] = [];
  timer: any;

  constructor(props) {
    super(props);

    this.state = {
      activeTab: 'questions',
      callResponse: callResponseSchema.initialize(),
      error: {
        questionResponse: null,
        order: null,
        competitorPricing: null,
      },
      callStartAt: '',
      callEndAt: '',
      alert: false,
      remarks: '',
      selectedProduct: {},
      alertSubmit: false,
    };
  }

  componentDidMount() {
    this.setState({ callStartAt: moment().format() });
  }

  onQuestionChange = (questionId, response, index) => {
    const callResponse = { ...this.state.callResponse };
    if (!callResponse.questionResponse[index]) {
      callResponse.questionResponse[index] = {
        response: '',
        questionId: '',
      };
    }
    callResponse.questionResponse[index].response = response;
    callResponse.questionResponse[index].questionId = questionId;
    this.setState({ callResponse });
  }

  gotoOrderBooking = () => {
    const { callResponse, error } = this.state;
    const errors: Error = callResponseSchema.validate(callResponse);
    const isError = errors.questionResponse.some((v) => !!v.response);
    if (isError) {
      return this.setState({ error: { ...error, questionResponse: errors.questionResponse } });
    }
    this.setState({ activeTab: 'order' });
  }

  onOrderBookingProductChange = (product: ProductNode, index: number) => {
    const { callResponse } = this.state;
    callResponse.order[index].productId = product.id;
    this.products[index] = product;
    this.setState({ callResponse }, () => this.calculateCasesPieces('cases', index));
  }

  onOrderBookingChange = (key: 'cases' | 'pieces', value: string, index: number) => {
    const { callResponse } = this.state;
    callResponse.order[index][key as string] = value;
    this.setState({ callResponse }, () => this.calculateCasesPieces(key, index));
  }

  setProductInOrderBooking = (selectedProduct: ProductNodeEdge, index: number) => {
    this.setState({ selectedProduct: { ...this.state.selectedProduct, [index]: selectedProduct } });
  }

  calculateCasesPieces = (key: 'cases' | 'pieces', index: number) => {
    const product = this.products[index];
    if (!product) {
      return;
    }
    const callResponse = { ...this.state.callResponse };
    const order = callResponse.order[index];
    if (key === 'cases') {
      callResponse.order[index].pieces = product.currentcasesize * order.cases;
    } else {
      callResponse.order[index].cases = product.currentcasesize / order.pieces;
    }
    this.setState({ callResponse });
  }

  onRowUpdate = (type: '-' | '+', key: string, index: number) => {
    const callResponse = { ...this.state.callResponse };
    if (type === '+' && key === 'order') {
      callResponse[key].push({
        productId: '',
        cases: 0,
        pieces: 0,
      });
      return this.setState({ callResponse });
    }
    if (type === '+' && key === 'competitorPricing') {
      callResponse[key].push({
        brand: '',
        packing: '',
        rate: 0,
      });
      return this.setState({ callResponse });
    }
    callResponse[key].splice(index, 1);
    this.setState({ callResponse });
  }

  gotoCompetitor = () => {
    const { callResponse, error } = this.state;
    const errors: Error = callResponseSchema.validate(callResponse);
    const isError = errors.order.some((v) => !!(v.productId && v.cases && v.pieces));
    if (isError) {
      return this.setState({ error: { ...error, order: errors.order } });
    }
    this.setState({ activeTab: 'pricing' });
  }

  onCompetitorPricingChange = (key: string, value: string, index: number) => {
    const { callResponse } = this.state;
    callResponse.competitorPricing[index][key as string] = value;
    this.setState({ callResponse });
  }

  gotoFinalScreen = () => {
    const { callResponse, error } = this.state;
    const errors: Error = callResponseSchema.validate(callResponse);
    const isError = errors.competitorPricing.some((v) => !!(v.brand && v.rate && v.packing));
    if (isError) {
      return this.setState({ error: { ...error, competitorPricing: errors.competitorPricing } });
    }
    this.setState({ activeTab: 'finalScreen' });
  }

  onSumbit = () => {
    this.props.disableAnswerSubmitButton();
    const callResponse: CallResponseMutationInput = {
      order: this.state.callResponse.order.map(
        (v) => JSON.stringify({ ...v, productId: fromGlobalId(v.productId) }) as any),
      competitorPricing: this.state.callResponse.competitorPricing.map((v) => JSON.stringify(v) as any),
      remarks: this.state.remarks,
      isAlert: this.state.alert,
      answers: this.state.callResponse.questionResponse.map((v) => JSON.stringify(v) as any),
      workHistory: '',
      addedBy: '',
      call: '',
    };

    const callHistory: CallHistoryMutationInput = {
      callStart: this.state.callStartAt,
      callEnd: moment().format(),
      callStatus: CallStatusEnum.ANSWERED,
      mobileNumber: '',
      retailer: '',
    };

    this.props.onSubmit(callResponse, callHistory);
  }

  render() {
    const { activeTab, callResponse, error } = this.state;

    return (
      <Card
        title='Call Response'
      >
        <Tabs defaultActiveKey={activeTab}>
          <TabPanel title='Questions' name='questions'>
            <Questions
              state={this.props.state}
              town={this.props.town}
              questionResponse={callResponse.questionResponse.map((v) => v.response)}
              onChange={this.onQuestionChange}
              onNext={this.gotoOrderBooking}
              error={error.questionResponse}
            />
            <ButtonGroup>
              <Button
                onClick={() => {
                  this.setState({ alert: false });
                  this.onSumbit();
                }}
                style={{ marginLeft: '10px' }}
                type='primary'
                disabled={this.props.isAnswerSubmitDisabled}
              >
                Submit
              </Button>
              <Popover
                position='top'
                onVisibleChange={(e) => {
                  !e && this.state.remarks.trim().length > 0 && this.onSumbit();
                  this.setState({ alertSubmit: false});
                }}
                content={
                  <div>
                    Remarks
                    <br />
                    <textarea
                      value={this.state.remarks}
                      onChange={(e) => this.setState({ remarks: e.target.value })}
                      onKeyUp={() => {
                        this.state.remarks.trim().length > 0
                          ? this.setState({ alertSubmit: false})
                          : this.setState({ alertSubmit: true});
                      }}
                    />
                    {this.state.alert && <span style={{ color: 'red' }}>Remarks is required</span>}
                  </div>
                }
              >
                <Button
                  onClick={() => {
                    this.setState({ alert: true });
                  }}
                  style={{ marginLeft: '800px' }}
                  type='danger'
                  disabled={this.state.alertSubmit || this.props.isAnswerSubmitDisabled}
                >
                  Submit with alert
                </Button>
              </Popover>
            </ButtonGroup>
          </TabPanel>
          {/* <TabPanel title='Order Booking' name='order'>
            <OrderBooking
              orders={callResponse.order}
              onProductChange={this.onOrderBookingProductChange}
              onChange={this.onOrderBookingChange}
              error={error.order}
              onRowUpdate={this.onRowUpdate}
              onNext={this.gotoCompetitor}
              selectedProduct={this.state.selectedProduct}
              setProduct={this.setProductInOrderBooking}
            />
          </TabPanel>
          <TabPanel title='Competitor Pricing' name='pricing'>
            <CompetitorPricing
              competitorPricing={callResponse.competitorPricing}
              onRowUpdate={this.onRowUpdate}
              error={error.competitorPricing}
              onChange={this.onCompetitorPricingChange}
              onNext={this.gotoFinalScreen}
            />
          </TabPanel> */}
        </Tabs>
      </Card>
    );
  }
}

interface Props {
  town: string;
  state: string;
  onSubmit: (callResponse: CallResponseMutationInput, callHistory: CallHistoryMutationInput) => void;
  isAnswerSubmitDisabled: boolean;
  disableAnswerSubmitButton: () => void;
}

type Error = {
  [key in keyof CallResponse]: any[];
};

interface State {
  activeTab: string;
  callResponse: CallResponse;
  error: Error;
  callStartAt: string;
  callEndAt: string;
  alert: boolean;
  remarks: string;
  selectedProduct: {
    [index: number]: ProductNodeEdge;
  };
  alertSubmit: boolean;
}
